<template>
  <div
    :class="[
      'd-flex title-widget text-h5 text-md-h3 font-weight-medium primary--text text--darken-1',
      className,
      !small ? 'text-h5 text-md-h3' : 'text-h6 text-sm-h5 text-md-h4',
    ]"
  >
    <span class="font-bazinga">
      <slot />
    </span>
  </div>
</template>

<script>
export default {
  props: {
    align: {
      type: String,
      default: "center",
      validator: (val) => ["left", "center", "right"].includes(val),
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    className() {
      const classNameAlign = {
        left: "text-left justify-start",
        center: "text-center justify-center",
        right: "text-right justify-end",
      };

      return classNameAlign[this.align] || "";
    },
  },
};
</script>

<style>
.title-widget {
  display: inline-block;
  color: #1e1e1e;
}
</style>
